export default {
    boderRadius: '20px',
    mainCard:{
        padding: '30px 25px',
    },
    subCard: {
        padding: '25px'
    }
}